import React, { useEffect, useState } from "react";
import {
  Layout,
  Button,
  Card,
  Row,
  Col,
  DatePicker,
  Table,
  message,
} from "antd";
import { DownloadOutlined } from "@ant-design/icons"; // Import DownloadOutlined icon
import "./Styles/staffManagement.css"; // Assuming you have a CSS file for styling
import axios from "axios"; // Import Axios
import moment from "moment";
import * as XLSX from "xlsx"; // Import XLSX

const { Content } = Layout;
const { RangePicker } = DatePicker;

const Reports = () => {
  const [activeTab, setActiveTab] = useState("addStaff");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dataSource, setDataSource] = useState([]); // Set initial data source

  const [vendorId, setVendorId] = useState(null);

  const handleSubmit = async () => {
    if (!startDate || !endDate || !vendorId) {
      message.error(
        "Please select the date range and ensure vendor ID is set."
      );
      return;
    }

    try {
      const response = await axios.post(
        "https://app-tl2d3sc25q-uc.a.run.app/api/order_history_admin",
        {
          from_date: startDate,
          to_date: endDate,
        }
      );

      if (response) {
        setDataSource(response.data);
        console.log(response.data);
        message.success("Data fetched successfully");
      } else {
        message.error("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("An error occurred while fetching data");
    }
  };

  useEffect(() => {
    const VendorId = localStorage.getItem("vendor_id");
    setVendorId(VendorId);
  }, []);
  const handleDownload = () => {
    const formattedData = dataSource.map((item, index) => ({
      "S.No": index + 1,
      "Order Id": item.order_id,
      "Date & Time": moment(item.order_date).format("DD/MM/YYYY hh:mm A"),
      "Packed Date & Time": item.packed_time
        ? moment(item.packed_time).format("DD/MM/YYYY hh:mm A")
        : "N/A",
      "Shipped Date & Time": item.readytoship_time
        ? moment(item.readytoship_time).format("DD/MM/YYYY hh:mm A")
        : "N/A",
      "Pickup Date & Time": item.pickedup_time
        ? moment(item.pickedup_time).format("DD/MM/YYYY hh:mm A")
        : "N/A",
      "Customer Name": `${item.first_name} ${item.last_name}`,
      "Customer Phone": item.phone,
      Status: item.status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Order History");
    XLSX.writeFile(workbook, "Order_History.xlsx");
  };

  // Columns configuration for the table
  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Order Id",
      dataIndex: "order_id",
      key: "order_id",
    },
    {
      title: "Date & Time",
      dataIndex: "order_date",
      key: "order_date",
      render: (text) => moment(text).format("DD/MM/YYYY hh:mm A"),
    },
    {
      title: "Packed Date & Time",
      dataIndex: "packed_time",
      render: (text) =>
        text ? moment(text).format("DD/MM/YYYY hh:mm A") : "N/A",
    },
    {
      title: "Shiped Date & Time",
      dataIndex: "readytoship_time",
      render: (text) =>
        text ? moment(text).format("DD/MM/YYYY hh:mm A") : "N/A",
    },

    {
      title: "Pickup Date & Time",
      dataIndex: "pickedup_time",
      key: "pickedup_time",
      render: (text) =>
        text ? moment(text).format("DD/MM/YYYY hh:mm A") : "N/A",
    },
    {
      title: "Vendor Name",
      key: "vendor_name",
      render: (text, record) => `${record.vendor_name}`,
    },
    {
      title: "Store Name",
      dataIndex: "store_name",
      key: "store_name",
    },

    {
      title: "Customer Name",
      dataIndex: "first_name",
      render: (text, record) => `${record.first_name} ${record.last_name}`,
    },
    {
      title: "Customer Phone",
      dataIndex: "phone",
      key: "sales_executive_name",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
  ];

  const generateLabel = async (record) => {
    try {
      // Call the API to request PDF generation
      const response = await fetch(
        "https://app-tl2d3sc25q-uc.a.run.app/api/get_shipping_label",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ orderId: record.order_id }), // Send order_id to API
        }
      );

      if (!response.ok) {
        throw new Error("Failed to request PDF generation");
      }

      // Convert the response to a blob (binary data)
      const blob = await response.blob();

      // Create a URL for the blob and open it
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
      message.success("PDF generated successfully");
    } catch (error) {
      console.error("Error generating PDF:", error);
      message.error("Error generating PDF");
    }
  };

  // Custom title for the table with download button
  const tableTitle = () => (
    <Row justify="space-between" align="middle">
      <Col>
        <RangePicker
          onChange={(dates, dateStrings) => {
            setStartDate(dateStrings[0]);
            setEndDate(dateStrings[1]);
          }}
        />
      </Col>
      <Col>
        <Button type="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </Col>
      <Col>
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          onClick={handleDownload}
        >
          Download
        </Button>
      </Col>
    </Row>
  );

  return (
    <Layout className="admin-dashboard-layout">
      <Content className="admin-dashboard-content">
        <Card title="Order History" className="admin-dashboard-card">
          <Table
            dataSource={dataSource}
            columns={columns}
            title={tableTitle}
            scroll={{ x: 1200, y: 500 }}
          />
        </Card>
      </Content>
    </Layout>
  );
};

export default Reports;
